import { SupportedLanguage } from '@/enum'
import { DropdownOption } from '@/types'

export const MOTHER_TONGUE_OPTIONS: DropdownOption = {
  [SupportedLanguage.English]: [
    'Hindi-Delhi',
    'Hindi-Madhya Pradesh/Chhattisgarh',
    'Hindi-Uttar Pradesh/Uttarakhand',
    'Punjabi',
    'Hindi-Bihar/Jharkhand',
    'Hindi-Rajasthan',
    'Haryanvi',
    'Himachali',
    'Kashmiri',
    'Sindhi',
    'Urdu',
    'Marathi',
    'Gujarati',
    'Kutchi',
    'Konkani',
    'Sindhi',
    'Tamil',
    'Telugu',
    'Kannada',
    'Malayalam',
    'Tulu',
    'Urdu',
    'Bengali',
    'Oriya',
    'Assamese',
    'Sikkim/Nepali',
    'English',
  ],
  [SupportedLanguage.Hindi]: [
    'हिंदी-दिल्ली',
    'हिंदी-मध्य प्रदेश/छत्तीसगढ़',
    'हिंदी-उत्तर प्रदेश/उत्तराखंड',
    'पंजाबी',
    'हिंदी-बिहार/झारखंड',
    'हिंदी-राजस्थान',
    'हरियाणवी',
    'हिमाचली',
    'कश्मीरी',
    'सिंधी',
    'उर्दू',
    'मराठी',
    'गुजराती',
    'कच्छी',
    'कोंकणी',
    'सिंधी',
    'तमिल',
    'तेलुगु',
    'कन्नड़',
    'मलयालम',
    'तुलु',
    'उर्दू',
    'बंगाली',
    'उड़िया',
    'असमिया',
    'सिक्किमी/नेपाली',
    'अंग्रेज़ी',
  ],
  [SupportedLanguage.Marathi]: [
    'हिंदी-दिल्ली',
    'हिंदी-मध्य प्रदेश/छत्तीसगड',
    'हिंदी-उत्तर प्रदेश/उत्तराखंड',
    'पंजाबी',
    'हिंदी-बिहार/झारखंड',
    'हिंदी-राजस्थान',
    'हरियाणवी',
    'हिमाचली',
    'काश्मीरी',
    'सिंधी',
    'उर्दू',
    'मराठी',
    'गुजराती',
    'कच्छी',
    'कोंकणी',
    'सिंधी',
    'तामिळ',
    'तेलुगू',
    'कन्नड',
    'मल्याळम',
    'तुळू',
    'उर्दू',
    'बंगाली',
    'ओडिया',
    'आसामी',
    'सिक्कीम/नेपाली',
    'इंग्रजी',
  ],
  [SupportedLanguage.Gujarati]: [
    'હિન્દી-દિલ્હી',
    'હિન્દી-મધ્ય પ્રદેશ/છત્તીસગઢ',
    'હિન્દી-ઉત્તર પ્રદેશ/ઉત્તરાખંડ',
    'પંજાબી',
    'હિન્દી-બિહાર/ઝારખંડ',
    'હિન્દી-રાજસ્થાન',
    'હરિયાણવી',
    'હિમાચલી',
    'કાશ્મીરી',
    'સિંધી',
    'ઉર્દુ',
    'મરાઠી',
    'ગુજરાતી',
    'કચ્છી',
    'કોંકણી',
    'સિંધી',
    'તમિલ',
    'તેલુગુ',
    'કન્નડ',
    'મલયાલમ',
    'તુલુ',
    'ઉર્દુ',
    'બંગાળી',
    'ઓડિયા',
    'અસમીસ',
    'સિક્કિમ/નેપાળી',
    'અંગ્રેજી',
  ],
  [SupportedLanguage.Bengali]: [
    'হিন্দি-দিল্লি',
    'হিন্দি-মধ্যপ্রদেশ/ছত্তিশগড়',
    'হিন্দি-উত্তরপ্রদেশ/উত্তরাখণ্ড',
    'পাঞ্জাবি',
    'হিন্দি-বিহার/ঝাড়খণ্ড',
    'হিন্দি-রাজস্থান',
    'হরিয়ানভি',
    'হিমাচালি',
    'কাশ্মীরি',
    'সিন্ধি',
    'উর্দু',
    'মারাঠি',
    'গুজরাটি',
    'কুচি',
    'কোঙ্কণি',
    'সিন্ধি',
    'তামিল',
    'তেলেগু',
    'কন্নড়',
    'মালায়ালম',
    'তুলু',
    'উর্দু',
    'বাংলা',
    'ওড়িয়া',
    'অসমীয়া',
    'সিকিম/নেপালি',
    'ইংরেজি',
  ],
  [SupportedLanguage.Telugu]: [
    'హిందీ-దిల్లీ',
    'హిందీ-మధ్యప్రదేశ్/ఛత్తీస్‌గఢ్',
    'హిందీ-ఉత్తరప్రదేశ్/ఉత్తరాఖండ్',
    'పంజాబీ',
    'హిందీ-బీహార్/జార్ఖండ్',
    'హిందీ-రాజస్థాన్',
    'హర్యాణవి',
    'హిమాచలి',
    'కశ్మీరీ',
    'సింధీ',
    'ఉర్దూ',
    'మరాఠీ',
    'గుజరాతీ',
    'కుచ్చి',
    'కోంకణీ',
    'సింధీ',
    'తమిళం',
    'తెలుగు',
    'కన్నడ',
    'మలయాళం',
    'తులు',
    'ఉర్దూ',
    'బంగాళీ',
    'ఓడియా',
    'ఆసామీ',
    'సిక్కిం/నేపాలీ',
    'ఆంగ్లం',
  ],
  [SupportedLanguage.Kannada]: [
    'ಹಿಂದಿ-ದೆಹಲಿ',
    'ಹಿಂದಿ-ಮಧ್ಯಪ್ರದೇಶ/ಛತ್ತೀಸ್‌ಗಢ',
    'ಹಿಂದಿ-ಉತ್ತರಪ್ರದೇಶ/ಉತ್ತರಾಖಂಡ',
    'ಪಂಜಾಬಿ',
    'ಹಿಂದಿ-ಬಿಹಾರ/ಝಾರ್ಖಂಡ',
    'ಹಿಂದಿ-ರಾಜಸ್ಥಾನ',
    'ಹರಿಯಾಣವಿ',
    'ಹಿಮಾಚಲಿ',
    'ಕಾಶ್ಮೀರಿ',
    'ಸಿಂಧಿ',
    'ಉರ್ದು',
    'ಮರಾಠಿ',
    'ಗುಜರಾತಿ',
    'ಕುಟ್ಚಿ',
    'ಕೊಂಕಣಿ',
    'ಸಿಂಧಿ',
    'ತಮಿಳು',
    'ತೆಲುಗು',
    'ಕನ್ನಡ',
    'ಮಲಯಾಳಂ',
    'ತುಳು',
    'ಉರ್ದು',
    'ಬಂಗಾಳಿ',
    'ಒರಿಯಾ',
    'ಅಸ್ಸಾಮಿ',
    'ಸಿಕ್ಕಿಂ/ನೇಪಾಳಿ',
    'ಇಂಗ್ಲಿಷ್',
  ],
  [SupportedLanguage.Tamil]: [
    'ஹிந்தி-தில்லி',
    'ஹிந்தி-மத்தியப் பிரதேசம்/சத்தீஸ்கர்',
    'ஹிந்தி-உத்தரப் பிரதேசம்/உத்தரகண்ட்',
    'பஞ்சாபி',
    'ஹிந்தி-பீஹார்/ஜார்க்கண்ட்',
    'ஹிந்தி-ராஜஸ்தான்',
    'ஹரியான்வி',
    'ஹிமாச்சலி',
    'காஷ்மீரி',
    'சிந்தி',
    'உருது',
    'மராத்தி',
    'குஜராத்தி',
    'குட்சி',
    'கொங்கணி',
    'சிந்தி',
    'தமிழ்',
    'தெலுங்கு',
    'கன்னடம்',
    'மலையாளம்',
    'துளு',
    'உருது',
    'பெங்காலி',
    'ஒடியா',
    'அசாமி',
    'சிக்கிம்/நேபாளி',
    'ஆங்கிலம்',
  ],
  [SupportedLanguage.Odia]: [
    'ହିନ୍ଦୀ-ଦିଲ୍ଲୀ',
    'ହିନ୍ଦୀ-ମଧ୍ୟ ପ୍ରଦେଶ/ଛତିଶଗଡ଼',
    'ହିନ୍ଦୀ-ଉତ୍ତର ପ୍ରଦେଶ/ଉତ୍ତରାଖଣ୍ଡ',
    'ପଞ୍ଜାବୀ',
    'ହିନ୍ଦୀ-ବିହାର/ଝାରଖଣ୍ଡ',
    'ହିନ୍ଦୀ-ରାଜସ୍ଥାନ',
    'ହରିୟାଣ୍ଭୀ',
    'ହିମାଚଳୀ',
    'କାଶ୍ମୀରୀ',
    'ସିନ୍ଧୀ',
    'ଉର୍ଦ୍ଦୁ',
    'ମରାଠୀ',
    'ଗୁଜୁରାତୀ',
    'କୁଚ୍ଛୀ',
    'କୋଙ୍କଣୀ',
    'ସିନ୍ଧୀ',
    'ତାମିଲ୍',
    'ତେଲୁଗୁ',
    'କନ୍ନଡ଼',
    'ମଲୟାଳମ୍',
    'ତୁଲୁ',
    'ଉର୍ଦ୍ଦୁ',
    'ବେଙ୍ଗାଳୀ',
    'ଓଡ଼ିଆ',
    'ଅସମୀୟା',
    'ସିକ୍କିମ/ନେପାଳୀ',
    'ଇଂରାଜୀ',
  ],
  [SupportedLanguage.Malayalam]: [
    'ഹിന്ദി-ഡൽഹി',
    'ഹിന്ദി-മധ്യപ്രദേശ്/ഛത്തീസ്ഗഢ്',
    'ഹിന്ദി-ഉത്തർപ്രദേശ്/ഉത്തരാഖണ്ഡ്',
    'പഞ്ചാബി',
    'ഹിന്ദി-ബിഹാർ/ജാർഖണ്ഡ്',
    'ഹിന്ദി-രാജസ്ഥാൻ',
    'ഹരിയാൻവി',
    'ഹിമാചലി',
    'കശ്മീരി',
    'സിന്ധി',
    'ഉറുദു',
    'മറാഠി',
    'ഗുജറാത്തി',
    'കച്ഛി',
    'കൊങ്കണി',
    'സിന്ധി',
    'തമിഴ്',
    'തെലുങ്ക്',
    'കന്നഡ',
    'മലയാളം',
    'തുളു',
    'ഉറുദു',
    'ബംഗാളി',
    'ഒഡിയ',
    'അസ്സമീസ്',
    'സിക്കിം/നേപ്പാളി',
    'ഇംഗ്ലീഷ്',
  ],
}
